module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[88]331.c66c8ca.woff2";